export const MOBILE_APP_ICON_HEIGHT = 35;
export const MOBILE_APP_ICON_WIDTH = 35;
export const MOBILE_APP_ICON_GIF_OR_SVG = 'mobile-app-icon-gif-or-svg';
export const MOBILE_APP_ICON = 'mobile-app-icon';
